export function initSubscriptionsManagement() {
	const $updateSubscriptionEmailContainer = $("#sfwc-change-subscription-email");
	const $updateSubscriptionEmailBtn = $("#sfwc-change-subscription-email__btn");
	if ($updateSubscriptionEmailContainer.length && $updateSubscriptionEmailBtn.length) {
		$updateSubscriptionEmailBtn.click((e) => {
			$updateSubscriptionEmailContainer.toggleClass("sfwc-change-subscription-email--update");
		});
	}

	$(document).on("click", "[data-cancel-multiple-subscriptions]", async (e) => {
		e.preventDefault();

		const $form = $("#cancel-multiple-subscriptions-form");
		const $checkedBoxes = $form.find('input[name="cancel-subscription[]"]:checked');
		const $modalContainer = window.sfModal.elements.container;

		if ($checkedBoxes.length === 0) {
			alert("Please select at least one subscription to cancel");
			return;
		}

		$modalContainer.addClass("sf-loading"); // add loading spinner to modal

		$checkedBoxes.each(function () {
			const cancelUrl = $(this).data("cancel-url");
			try {
				$.ajax({
					url: cancelUrl,
					method: "GET"
				})
					.done(() => {
						console.log(`Successfully cancelled subscription`);
						window.location.reload();
					})
					.fail((error) => {
						console.error(`Error cancelling subscription ${$(this).val()}:`, error);
						alert(`Error cancelling subscriptions, please contact us for support`);
						$modalContainer.removeClass("sf-loading"); // remove loading spinner from modal
					});
			} catch (error) {
				console.error(`Error cancelling subscription ${$(this).val()}:`, error);
				alert(`Error cancelling subscriptions, please contact us for support`);
				$modalContainer.removeClass("sf-loading"); // remove loading spinner from modal
			}
		});
	});
}
